import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';
import { Lender } from 'enums/ApplicationsVariables';

export enum BorrowerOwnership {
  Buying = 'Buying',
  LiveWithParents = 'LiveWithParents',
  Own = 'Own',
  Rent = 'Rent',
}

export interface UpdateHomeOwnershipRequestDto {
  applicationId: string;
  moveInDate: string;
  ownershipStatus: BorrowerOwnership;
  previousAddress?: {
    streetName: string;
    streetNumber: string;
    city: string;
    stateOrProvince: string;
    zipOrPostalCode: string;
  };
  previousMoveInDate?: string;
}

export interface UpdateCoOwnerDto {
  applicationId: string;
  email: string;
  lender: Lender;
  phoneNumber?: string;
  last4SSN?: string;
}

export class HomeOwnershipsApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/homeOwnerships' || '');
  }

  public async updateHomeOwnership(updateHomeOwnershipRequestDto: UpdateHomeOwnershipRequestDto): Promise<void> {
    return this.instance.put('', updateHomeOwnershipRequestDto).then((response: AxiosResponse<void>) => response.data);
  }

  public async updateCoOwner(updateCoOwnerDto: UpdateCoOwnerDto): Promise<void> {
    return this.instance.put('/coOwners', updateCoOwnerDto).then((response: AxiosResponse<void>) => response.data);
  }
}

export const homeOwnershipsApi = new HomeOwnershipsApi();
